<template>
    <div v-loading="loading" v-bind:element-loading-text="$t('message.Desperately_loading')" element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)">
      <el-container>
        <el-header>
          <head_page :head_page_type=false ref="head_page"></head_page>
        </el-header>
        <el-main>
          <div id='choose_city'>
            <head_menu :has-back=true >
               
            </head_menu>
            <div style="background-color: white;" id="searchDiv" >
            
            <el-row>
                <el-col :span=6 style="text-align: center;height:950px;" >
                    <div style = " height:935px;background-color: rgb(240, 240, 238);margin-top:10px;margin-right: 10px;"  
                    
                    >
                    <!--  :class="{'is_fixed' : isFixed}" -->
                        <div style="    font-size: 24px;padding-top: 20px;text-align: left;padding-left: 20px;">{{$t('message.Search_by')  }}</div>
                        <div style="    font-size: 14px;padding-top: 20px;text-align: left;padding-left: 10%;">{{$t('message.Date_range')  }}</div>
                        <div style="padding-left: 10%;text-align: left"><el-date-picker :clearable = false  v-model="selectDate"  style="width:85%;" type="daterange" range-separator="-" start-placeholder="开始日期" value-format="yyyy-MM-dd" end-placeholder="结束日期" :picker-options="pickerOptions"></el-date-picker></div>
                        <div style="    font-size: 14px;padding-top: 15px;text-align: left;padding-left: 10%;">{{$t('message.Metrics')  }}</div>
                        <div style="padding-left: 10%;text-align: left">
                            <el-select style="width: 85%;" v-model="metrics" placeholder=""  @change="selectMetricsChanged"  >
                                <el-option :label="$t('message.Sessions')" value="Sessions" :title="$t('message.Definition_session')"></el-option>
                                <el-option :label="$t('message.Activities')" value="Activities"  :title="$t('message.Definition_activity')"></el-option>
                                <el-option :label="$t('message.UV')" value="UV" :title="$t('message.Definition_UV')"></el-option>
                                <el-option :label="$t('message.New_proposal')" value="New Proposal" :title="$t('message.Definition_New_proposal')" ></el-option>
                                <el-option :label="$t('message.Active_proposal')" value="Active Proposal" :title="$t('message.Definition_Active_proposal')"></el-option>
                            </el-select>
                        </div>
                        <div style="    font-size: 14px;padding-top: 15px;text-align: left;padding-left: 10%;">{{$t('message.Dimension')}}</div>
                        <div style="padding-left: 10%;text-align: left">
                            <el-select style="width: 85%;" v-model="bu_dimension"  placeholder="" @change="selectDimensionChanged">
                                <el-option
                                        v-for="item in bu_dimension_option"
                                            :key="item.id"     
                                            :label="item.name"
                                            :value="item.id"
                                />

                            </el-select>
                        </div>
                        <div style="    font-size: 14px;padding-top: 15px;text-align: left;padding-left: 10%;">{{$t('message.Dimension_filter')}}</div>
                        <div style="padding-left: 10%;text-align: left">
                            <el-select style="width: 85%;" v-model="bu_dimension_filter"  @change="changeSelectDimensionFilter" placeholder="" multiple collapse-tags>
                                <el-option
                                        v-for="item in bu_dimension_filter_option"
                                            :key="item.id"     
                                            :label="item.name"
                                            :value="item.id"
                                />
                            </el-select>
                        </div>
                        <div style="    font-size: 14px;padding-top: 15px;text-align: left;padding-left: 10%">{{$t('message.Time_dimension')}}</div>
                        <div style="padding-left: 10%;text-align: left">
                            <el-select style="width: 85%;" v-model="time_dimension"  placeholder="">
                                <el-option
                                        v-for="item in time_dimension_option"
                                            :key="item.id"     
                                            :label="item.name"
                                            :value="item.id"
                                />
                            </el-select>
                        </div>
                        <div style="  text-align: center;  font-size: 14px;padding-top: 15px;padding-left: 0px;">
                            <el-button @click = "submit()">{{$t('message.Submit')}}</el-button>
                        </div>
                        <div style="  text-align: center;  font-size: 14px;padding-top: 15px;padding-left: 0px;">
                            <el-button @click = "exportExcel()">{{$t('message.Export')}}</el-button>
                        </div>
                        <div v-if="(bu!= 'DDV' && bu!='Central') && bu_dimension == 'City'" style="  color:grey;  font-size: 8px;padding-top: 15px;text-align: left;padding-left: 25px;font-style:italic">{{$t('message.remark_search').replace('bu', bu)}}</div>
                    </div>
                </el-col>
               
              
                <el-col :span=18 style="text-align: center;">
                    <div style = " height:950px;margin-top: 10px; margin-right: 15px;">
                        
                        <div style="height: 80px;">
                            <el-col :span="12">  <el-card class="box-card" style="margin-right: 5px;height: 75px;">
     
     <div ><img  style = "height: 45px;position: relative;top: 5px;float: left;left: 20px;" src="../src/assets/metrics.png" alt="jcd_logo_1" />{{$t('message.'+metrics_result)}}<el-popover placement="top-start" trigger="hover">
<pre v-if="metrics_result == 'Activities'" >
{{$t('message.Definition_activity')}}
</pre >
<pre v-if="metrics_result == 'Sessions'" >
{{$t('message.Definition_session')}}
</pre >
<pre v-if="metrics_result == 'UV'" >
{{$t('message.Definition_UV')}}
</pre >
<pre v-if="metrics_result == 'New Proposal'" >
{{$t('message.Definition_New_proposal')}}
</pre >
<pre v-if="metrics_result == 'Active Proposal'" >
{{$t('message.Definition_Active_proposal')}} 
</pre >


<el-button
icon="el-icon-info"
circle
slot="reference"
style="border: 0px;"
></el-button>
</el-popover><br> <div style="color:#3399CC;font-size: 20px;font-weight: 800; margin-top: -10px;">{{total_count}}</div></div>
 </el-card>
                               </el-col>
                           <el-col :span="12">  
                                <el-card class="box-card"  style="margin-left: 5px;height: 75px;"><img  style = "height: 45px;position: relative;top: 5px;float: left;left: 20px;" src="../src/assets/trend.png" alt="jcd_logo_1" />{{$t('message.YOY')}} <br> 
     
     <div v-if="yoy> 0" style="color:#4DB6AC;font-size:16px"><div style = "display :inline-block;width: 0;height: 0;border-bottom: 10px solid #4DB6AC;border-left: 10px solid transparent;border-right: 10px solid transparent;"></div> <div style = "display: inline-block;font-size: 20px;font-weight: 800;">{{yoy}}</div><div style="display:inline-block; font-size:16px"> %</div>
     
     <el-popover placement="top-start" trigger="hover"> <pre>
{{$t('message.last_year_kpi')}}{{total_count_last}} 

</pre > <el-button
icon="el-icon-info"
circle
slot="reference"
style="border: 0px; "
></el-button></el-popover></div>
<div v-if="yoy<= 0" style="color:red;font-size:16px"><div style = "display :inline-block;width: 0;height: 0;border-top: 10px solid red;border-left: 10px solid transparent;border-right: 10px solid transparent;"></div> <div style = "display: inline-block;font-size: 20px;font-weight: 800;">{{yoy}}</div><div style="display:inline-block; font-size:16px"> %</div>
     
     <el-popover placement="top-start" trigger="hover"> <pre>
{{$t('message.last_year_kpi')}}{{total_count_last}} 
</pre >
 <el-button
icon="el-icon-info"
circle
slot="reference"
style="border: 0px; height: 20px;"
></el-button>
</el-popover></div>
 </el-card></el-col>
                        </div>
                        <!-- <div style="height: 220px;margin-top: 10px;">
                            <el-card style="height: 220px;">
     
                                <div style="height: 200px; width: 95%; margin-left: 15px;" id="chart_by_timeDimension"></div>
                            </el-card>

                        </div > -->
                        <div  style="height: 200px;margin-top: 5px;">
                            <el-col :span="24">
                                <el-card style="height: 200px;margin-right: 0px;">
                                    <!-- <div style="height: 170px; width: 100%; margin-left: 15px;" id="chart_by_bu_2"></div> -->
                                    <div style="height: 170px; width: 95%; margin-left: 15px;" id="chart_by_timeDimension"></div>
                                </el-card>
                            </el-col>
                            </div>
                            <div  style="height: 200px;margin-top: 10px;">
                                <el-col :span="8">
                                <el-card style="height: 200px;margin-right: 5px;">
                                    <div style="height: 170px; width: 100%; margin-left: 15px;" id="chart_by_bu_2"></div>
                                    
                                </el-card>
                            
                            </el-col>
                            <el-col :span="16">
                                <el-card style="height: 200px;margin-left: 5px;">
                                    <div style="height: 170px; width: 100%; margin-left: 15px;" id="chart_by_timeDimension_bu"></div>
                                </el-card>
                            </el-col>

                        </div>
                        <div  style="height: 200px;margin-top: 10px;">
                            <el-col :span="24">
                                <el-card style="height: 200px; margin-right: 0px;">
                                    <div style="height: 170px; width: 95%; margin-left: 15px;" id="chart_by_timeDimension_bu_2"></div>
                                </el-card>
                            </el-col>
                            <!-- <el-col :span="10">
                                <el-card style="height: 200px;margin-left: 5px;">
                                    <div style="height: 170px; width: 90%; margin-left: 15px;" id="chart_by_timeDimension_2"></div>
                                </el-card>
                            </el-col> -->
                        </div>
                        <div  style="height: 220px;margin-top: 10px;">
                            <el-col :span="24">
                                <el-card style="height: 220px;">
                                    <div style="height: 200px; width: 95%; margin-left: 15px;" id="chart_by_user"></div>
                                </el-card>
                            </el-col>
                        </div>
                    </div>
                </el-col>
              </el-row>
              
            </div>
            </div>
        </el-main>
        </el-container>
        </div>
        </template>
<script>
 
import head_page from './components/head_page.vue';
import head_menu from "./components/head_menu.vue";
import axios from 'axios';
import _global from './components/global.vue';
import echarts from 'echarts';
import FileSaver from 'file-saver'
import XLSX from 'xlsx'

export default {
        name: 'statistics_v2',
        components: {
            head_page,
            head_menu
        },
        data(){
            return{
                loading:false,
                isFixed: false,
                offsetTop: 0,

                selectDate:['',''],
                metrics:'Activities',
                metrics_result:'Activities',
                bu_dimension:'',
                bu_dimension_option:[{name:this.$t('message.BU_Statistic'),id:'BU'}],
                bu_dimension_filter:'DDV',
                bu_dimension_filter_option:[],
                time_dimension:'Date',
                time_dimension_option:[],
                total_count:0,
                total_count_last:0,
                yoy: 0,
                 pickerOptions: {
      onPick: this.getPickDate,
      disabledDate: this.disabledDate
     },
     pickDate:'',
     drawer:false,
     withHeader:false,

     option_chart1:'',
     option_chart2:'',
     option_chart3:'',
     option_chart4:'',
     option_chart5:'',

     bu:'',

                colorList : [
                '#3399CC',
                                '#006699',
                                '#66CCCC',
                                '#99CCFF',
                                '#CCFFFF',
                                '#99CCCC',
                                '#3399CC',
                                '#003366',
                                '#336699',
                                '#66CCCC',
                                '#003333',
                                '#006699',
                                '#66CCCC',
                                '#99CCFF',
                                '#CCFFFF',
                                '#99CCCC',
                                '#3399CC',
                                '#003366',
                                '#336699',
                                '#66CCCC',
                                '#003333',
                                '#006699',
                                '#66CCCC',
                                '#99CCFF',
                                '#CCFFFF',
                                '#99CCCC',
                                '#3399CC',
                                '#003366',
                                '#336699',
                                '#66CCCC',
                                '#003333',
                                '#006699',
                                '#66CCCC',
                                '#99CCFF',
                                '#CCFFFF',
                                '#99CCCC',
                                '#3399CC',
                                '#003366',
                                '#336699',
                                '#66CCCC',
                                '#003333',
                                '#006699',
                                '#66CCCC',
                                '#99CCFF',
                                '#CCFFFF',
                                '#99CCCC',
                                '#3399CC',
                                '#003366',
                                '#336699',
                                '#66CCCC',
                                '#003333',
                                '#006699',
                                '#66CCCC',
                                '#99CCFF',
                                '#CCFFFF',
                                '#99CCCC',
                                '#3399CC',
                                '#003366',
                                '#336699',
                                '#66CCCC',
                                '#003333',
                                '#006699',
                                '#66CCCC',
                                '#99CCFF',
                                '#CCFFFF',
                                '#99CCCC',
                                '#3399CC',
                                '#003366',
                                '#336699',
                                '#66CCCC',
                                '#003333',
                                ],
                                data_response:{},
        
            }
        },
        methods:{
            changeSelectDimensionFilter(val){
                if (this.bu_dimension_filter.length == 0) {
                    this.bu_dimension_filter.push(this.bu_dimension_filter_option[0]["id"]);
                }
            },
            getPickDate(pick) {
                this.pickDate = pick;
            },
            disabledDate(date) {
                const { minDate, maxDate } = this.pickDate;
                if (minDate && !maxDate) {
                const diff = Math.abs(minDate.valueOf() - date.valueOf());
                if (diff > 1000 * 3600 * 24 * 365) {
                    return true;
                }
                }
            },
            exportExcel(){
                let data_by_bu = []
                let data_by_time = []
                let data_by_time_bu = []
                let data_by_user = []

                for (let i= 0;i<this.data_response.db_by_bu_dimension_list.length;i++){
                    data_by_bu.push({'BU/City':this.data_response.db_by_bu_dimension_list[i].dimension_bu,'Total':this.data_response.db_by_bu_dimension_list[i].count})
                }
                for (let i= 0;i<this.data_response.db_by_time_dimension_list.length;i++){
                    data_by_time.push({'Time':this.data_response.db_by_time_dimension_list[i].dimension_time,'Total':this.data_response.db_by_time_dimension_list[i].count})
                }
                for (let i= 0;i<this.data_response.db_by_time_bu.length;i++){
                    data_by_time_bu.push({'Time':this.data_response.db_by_time_bu[i].dimension_time,'BU/City':this.data_response.db_by_time_bu[i].dimension_bu,'Total':this.data_response.db_by_time_bu[i].count})
                }
                for (let i= 0;i<this.data_response.db_user.length;i++){
                    data_by_user.push({'User':this.data_response.db_user[i].dimension,'Total':this.data_response.db_user[i].count})
                }
                let sheet_by_bu = XLSX.utils.json_to_sheet(data_by_bu);
                let sheet_by_time = XLSX.utils.json_to_sheet(data_by_time);
                let sheet_by_time_bu = XLSX.utils.json_to_sheet(data_by_time_bu);
                let sheet_by_user = XLSX.utils.json_to_sheet(data_by_user);


                let workbook = {
                    SheetNames: ["by_time_bu","by_time","by_bu","by_user"],
                    Sheets: {
                        by_time_bu: sheet_by_time_bu,
                        by_time:sheet_by_time,
                        by_bu:sheet_by_bu,
                        by_user:sheet_by_user
                    },
                };

                let wbout = XLSX.write(workbook, {
                    bookType: "xlsx",
                    bookSST: true,
                    type: "array",
                });

                FileSaver.saveAs(
                    new Blob([wbout], { type: "application/octet-stream" }),
                    'export.xlsx'
                );

            },
            goToOldVersion(){
                this.$router.push({
                    path: '/statistics',
                });

            },
            selectDimensionChanged(value){
                if(value == 'BU'){
                    if(this.bu == 'DDV' || this.bu == 'Central'){
                        this.bu_dimension_filter_option=[{name:'DDV',id:'DDV'},{name:'Central',id:'Central'},{name:'Nanjing',id:'Nanjing'},{name:'Wuhan',id:'Wuhan'},{name:'Shenzhen',id:'Shenzhen'},{name:'Chongqing',id:'Chongqing'},{name:'Chengdu',id:'Chengdu'},{name:'Shanghai',id:'Shanghai'},{name:'Beijing',id:'Beijing'},{name:'Hongkong',id:'Hongkong'}]
                    } else {
                        this.bu_dimension_filter_option=[{name:this.bu,id:this.bu}]
                    }
                } else {
                    this.bu_dimension_filter_option=[{name:'Nanjing',id:'Nanjing'},{name:'Wuhan',id:'Wuhan'},{name:'Chengdu',id:'Chengdu'},{name:'Shenzhen',id:'Shenzhen'},{name:'Chongqing',id:'Chongqing'},{name:'Beijing',id:'Beijing'},{name:'Hongkong',id:'Hongkong'}]
                }
                this.bu_dimension_filter = []
                
                this.bu_dimension_filter_option.map((item) => {
                    this.bu_dimension_filter.push(item["id"]);
                    

                })
            },
            selectMetricsChanged(value){

                if(value == 'UV' ){
                    
                    this.bu_dimension_option = [{name:this.$t('message.BU_Statistic'),id:'BU'},{name:this.$t('message.City_Statistic'),id:'City'}]
                    
                } else if (value == 'New Proposal'){
                  
                    this.bu_dimension_option = [{name:this.$t('message.BU_Statistic'),id:'BU'},{name:this.$t('message.City_Statistic'),id:'City'}]
                } else if (value == 'Active Proposal'){
                    this.bu_dimension_option = [{name:this.$t('message.BU_Statistic'),id:'BU'},{name:this.$t('message.City_Statistic'),id:'City'}]
                } 
                else {
                    
                    this.bu_dimension_option = [{name:this.$t('message.BU_Statistic'),id:'BU'},]
                    this.bu_dimension = 'BU'
                }
                this.bu_dimension_filter = []
                this.bu_dimension_filter_option = []
                if(this.bu == 'DDV' || this.bu == 'Central'){
                        this.bu_dimension_filter_option=[{name:'DDV',id:'DDV'},{name:'Central',id:'Central'},{name:'Nanjing',id:'Nanjing'},{name:'Wuhan',id:'Wuhan'},{name:'Shenzhen',id:'Shenzhen'},{name:'Chongqing',id:'Chongqing'},{name:'Chengdu',id:'Chengdu'},{name:'Shanghai',id:'Shanghai'},{name:'Beijing',id:'Beijing'},{name:'Hongkong',id:'Hongkong'}]
                    } else {
                        this.bu_dimension_filter_option=[{name:this.bu,id:this.bu}]
                }
                this.bu_dimension_filter_option.map((item) => {
                    this.bu_dimension_filter.push(item["id"]);
                    

                })

            },

            getChartByuser:function(arr){
                echarts.init(document.getElementById('chart_by_user')).dispose() 
                let chart_by_timeDimension = echarts.init(document.getElementById('chart_by_user'));
               
			let _self = this;
            this.option_chart5={
				title:{
					// show:false, //显示策略，默认值true,可选为：true（显示） | false（隐藏）
					text: _self.$t('message.chart_title_by_user').replace("{{metrics}}", _self.$t('message.'+_self.metrics)), //主标题文本，'\n'指定换行
					textStyle: { //主标题文本样式{"fontSize": 18,"fontWeight": "bolder","color": "#333"} 
							fontSize: 12,
							// color:'white'
					},
					x:'center',
					y:0
				},
				tooltip: {
					trigger: 'axis',
                    textStyle: {
                                            fontSize:10  // 字体大小
                                        },
				},
				legend: {
					// top:'2%',
					//x:'left',
                    show:false,
					textStyle:{
							// color: 'white'
					},
					//data: ['Actual Data', 'Last Forecast', 'New Forecast', 'BU Original Forecast', 'ForwardKeys']
					data: [this.metrics]
				},
				grid: {
					left: '5',
					top:'38',
					right: '5',
					bottom: arr.length> 15?'20':'10',
					containLabel: true
				},
				toolbox: {

				},
				xAxis: {
					
					data: arr.map(obj=>{return obj.dimension}),
                    axisLabel: {
                        interval: 0,
                        formatter: function (params) {
                                var newParamsName = ''
                                const paramsSpace = params.indexOf(" ")
                                const paramsNameNumber = params.length                                                                                         
                                var tempStr = ''
                                tempStr = params.substring(0, paramsSpace) + '\n' +params.substring(paramsSpace, paramsNameNumber)
                                return tempStr
                        }}
                },
				yAxis: {
					type: 'value',
					
				},
                dataZoom: [
                {
                    type: 'slider',
                    show: arr.length> 15?true:false,
                    height: 10,
                    bottom: 8,
                    borderColor: 'transparent',
                    backgroundColor: '#e2e2e2',
                    // 拖拽手柄样式 svg 路径
                    handleIcon: 'M512 512m-208 0a6.5 6.5 0 1 0 416 0 6.5 6.5 0 1 0-416 0Z M512 192C335.264 192 192 335.264 192 512c0 176.736 143.264 320 320 320s320-143.264 320-320C832 335.264 688.736 192 512 192zM512 800c-159.072 0-288-128.928-288-288 0-159.072 128.928-288 288-288s288 128.928 288 288C800 671.072 671.072 800 512 800z',
                    handleColor: '#99CCFF',
                    handleSize: 14,
                    handleStyle: {
                        borderColor: '#99CCFF',
                        shadowBlur: 4,
                        shadowOffsetX: 1,
                        shadowOffsetY: 1,
                        shadowColor: '#99CCFF'
                    },
                    startValue:0, // 从头开始。
                    endValue:14, // 一次性展示15个,
                    fillerColor:"#99CCFF",
                    zoomLock:'false',
                    showDataShadow: false,
                    textStyle:{
                        color:'rgba(0, 0, 0, 0)',
                        width:0
                    }
                }

                ],

				series: [
					{
						// name: 'Actual Data',
						name: this.metrics,
						type: 'bar',
                        barMaxWidth: '45%',
						
						data: arr.map(obj=>{return obj.count}),
                        itemStyle: {
                            normal: {
                                
                                color:'#99CCFF',
                            
                                label: {
                                    show: true, //开启显示
                                    position: 'top', //内部显示
                                    // formatter:function (params) {
                                    //     return params.value/100 + '%';
                                    // },
                                    textStyle: {
                                        //数值样式
                                        color: 'black',
                                        fontSize: 12,
                                    },
                                },
                            },
                        },
					},
					
				]
			}
			chart_by_timeDimension.setOption(this.option_chart5)
            },
            getChartByBU:function(arr){
                echarts.init(document.getElementById('chart_by_bu_2')).dispose() 
                let chart_by_timeDimension = echarts.init(document.getElementById('chart_by_bu_2'));
               
               let _self = this;
               this.option_chart2 =  {
                   title:{
                       // show:false, //显示策略，默认值true,可选为：true（显示） | false（隐藏）
                       text:_self.$t('message.chart_title_by_bu').replace("{{metrics}}", _self.$t('message.'+_self.metrics)).replace("{{bu_dimension}}",_self.$t('message.'+_self.bu_dimension+'_Statistic')) , //主标题文本，'\n'指定换行
                       textStyle: { //主标题文本样式{"fontSize": 18,"fontWeight": "bolder","color": "#333"} 
                               fontSize: 12,
                               // color:'white'
                       },
                       x:'center',
                       
                   },
                   tooltip: {
                       trigger: 'item',
                       textStyle: {
                                            fontSize:10  // 字体大小
                                        },
                       formatter:function(params) {
                    //   console.log(params)
                    //   var str = params[0].name + '<br>'
                    //   let circle = `<span style="display:inline-block;margin-right:5px;border-radius:50%;width:10px;height:10px;left:5px;background-color:`+params[0].color+
                    //                           `"></span>`;
                    //                           let circle_2 = `<span style="display:inline-block;margin-right:5px;border-radius:50%;width:10px;height:10px;left:5px;background-color:`+params[1].color+
                    //                           `"></span>`;
                    //   str += circle+params[0].seriesName + ' : ' + params[0].value + '<br>'
                    //   str += circle_2+params[1].seriesName + ' : ' + params[1].value + '%<br>'
                    if (_self.$i18n.locale == 'en'){
                        var str = '<div style=" height:auto; float:left; display:inline">'+_self.bu_dimension+':&nbsp </div> <div style=" height:auto; float:left; display:inline">'+params.data.name+'</div> '+'<br><div style=" height:auto; float:left; display:inline">Value:&nbsp</div> <div style=" height:auto; float:left; display:inline">'+params.data.value+'</div> '+'<br><div style=" height:auto; float:left; display:inline">Percent:&nbsp</div> <div style=" height:auto; float:left; display:inline">'+params.percent+'%</div> '
                    } else {
                        var str = '<div style=" height:auto; float:left; display:inline">'+_self.$t('message.'+_self.bu_dimension+'_Statistic')+'：</div> <div style=" height:auto; float:left; display:inline">'+params.data.name+'</div> '+'<br><div style=" height:auto; float:left; display:inline">值： </div> <div style=" height:auto; float:left; display:inline">'+params.data.value+'</div> '+'<br><div style=" height:auto; float:left; display:inline">百分比： </div> <div style=" height:auto; float:left; display:inline">'+params.percent+'%</div> '
                    }
                    // var str = '<div style=" height:auto; float:left; display:inline">'+_self.bu_dimension+' : </div> <div style=" height:auto; float:left; display:inline">'+params.data.name+'</div> '+'<br><div style=" height:auto; float:left; display:inline">Value : </div> <div style=" height:auto; float:left; display:inline">'+params.data.value+'</div> '+'<br><div style=" height:auto; float:left; display:inline">Percent : </div> <div style=" height:auto; float:left; display:inline">'+params.percent+'%</div> '
                      return str;
                  }
                   },
                   legend: {
                    //    orient: 'vertical',
                       bottom:0,
                    //    right: 'center',
                       type: 'scroll',
                       icon: "circle",//显示样式
                       pageIconColor: 'black', //图例分页左右箭头图标颜色
                           pageTextStyle:{  
                               color: 'black', //图例分页页码的颜色设置
                           },
                           pageIconSize: 12,  //当然就是按钮的大小
                           pageIconInactiveColor: '#7f7f7f',  // 禁用的按钮颜色
                       
                   },
                   series: [
                       {
                       name: this.metrics +' by ' +this.time_dimension,
                       type: 'pie',
                       radius: ['40%', '65%'],
                       center: ["48%", "52%"],
                       avoidLabelOverlap: false,
                       itemStyle: {
                      
                         normal: {
                            color: function (colors) {// 第二长图的颜色
                                
                                return _self.colorList[colors.dataIndex];
                            }},
                           
                           borderRadius: 10,
                           borderColor: '#fff',
                           borderWidth: 2
                       },
                       label: {
                           show: false,
                           position: 'center'
                       },
                       emphasis: {
                           label: {
                           show: false,
                           fontSize: 40,
                           fontWeight: 'bold'
                           }
                       },
                       labelLine: {
                           show: false
                       },
                       data: 
                       arr.map(item=>{return {name:item.dimension_bu,value:item.count}})
                       
                       }
                   ]
                   }
               chart_by_timeDimension.setOption(this.option_chart2)

            },
            getChartByTimeDimensionByBu_2:function(arr1,arr2,arr3){
                let _self = this
                
                let data_x = arr1.map(obj=>{return obj.dimension_time})
                let data_y = []
                for (let i = 0;i<arr3.length;i++){
                    let bu = arr3[i]['dimension_bu']
                    let count = []
                    for(let j = 0;j<data_x.length;j++){
                        var objectIndex = arr2.findIndex(object => ( object.dimension_time == data_x[j]) && ( object.dimension_bu == bu) );
                        
                     
                        if (objectIndex >= 0){
                            count.push(arr2[objectIndex].count)
                        } else {
                            count.push(0)
                        }
                    }
                   
                    let obj = [{bu_name:bu}]
                    obj.push({count:count})
                    data_y.push(obj)
                    
                  
                }
             
                let date = []; //x轴日期
                let lenged = []; //series的个数
                let s = [];
                arr2.map((item) => {
                    date.push(item["dimension_time"]);
                    lenged.push(item["dimension_bu"]);

                });

                date = [...new Set(date)]; //去重
                // lenged = [...new Set(lenged)];?]
                lenged = data_y.map(obj=>{return obj[0].bu_name})
                
               
                let series = [];
                lenged.map((item,index) => { //生成  series
                    let obj = {
                        name: item,
                        barMaxWidth: '45%',
                        //  barWidth : 30,
                        type: 'bar',
                        stack: 'Total',
      
                    emphasis: {
                        focus: 'series'
                    },
                    itemStyle: {
                            normal: {
                                color:this.colorList[index],// 第一张图的颜色
                                label: {
                                    // show: true, //开启显示
                                    position: 'top', //内部显示
                                    // formatter:function (params) {
                                    //     return params.value/100 + '%';
                                    // },
                                    textStyle: {
                                        //数值样式
                                        color: 'black',
                                        fontSize: 12,
                                    },
                                },
                            },
                        },
                                        data: []
                                    };

                                    series.push(obj);
                                });
                                series.map((item1,index) => {

                
                item1.data = data_y[data_y.findIndex(object => ( object[0].bu_name == item1.name) )][1]['count'];
                                    if(index == series.length -1){
                                        
                                            item1.itemStyle={
              normal: {
                color:this.colorList[index],
                label: {
                  show: true,
                  position: 'top',
                  textStyle: {
                    color: 'black',
                    fontSize: 10,
                  },
                  formatter: function (params) {
                   
                    return  arr1[arr1.findIndex(object => object.dimension_time == params.name)].count
                  },
                },
              },
            }
                                        
                                    }
                })
                
                echarts.init(document.getElementById('chart_by_timeDimension_bu_2')).dispose() 
                                let chart_by_timeDimension = echarts.init(document.getElementById('chart_by_timeDimension_bu_2'))
                                this.option_chart4 = {
                                    title: {
                                        text: _self.$t('message.chart_title_bu_bu_stacked').replace("{{metrics}}", _self.$t('message.'+_self.metrics)).replace("{{bu_dimension}}",_self.$t('message.'+_self.bu_dimension+'_Statistic')) , //主标题文本，'\n'指定换行,
                                        textStyle: { //主标题文本样式{"fontSize": 18,"fontWeight": "bolder","color": "#333"} 
                                            fontSize: 12,
                                        // color:'white'
                                        },
                                        x:'center'
                                    },
                                   
                                    tooltip: {
                                        textStyle: {
                                            fontSize:10  // 字体大小
                                        },
                                        trigger: 'axis',
                                        position: function (point, params, dom, rect, size) {
                                            var x = 0; // x坐标位置
                                                var y = 0; // y坐标位置
                                                // 当前鼠标位置
                                                var pointX = point[0];
                                                var pointY = point[1];
                                                // 提示框大小
                                                var boxWidth = size.contentSize[0];
                                                var boxHeight = size.contentSize[1];

                                                // boxWidth > pointX 说明鼠标左边放不下提示框
                                                if (boxWidth > pointX) {
                                                    x = pointX + 10;
                                                } else { // 左边放的下
                                                    x = pointX - boxWidth - 10;
                                                }

                                                // boxHeight > pointY 说明鼠标上边放不下提示框
                                                if (boxHeight > pointY) {
                                                    y = 5;
                                                } else { // 上边放得下
                                                    y = pointY - boxHeight;
                                                }
                                                return [x, y];
                                                    },
                                        axisPointer: {
                                        type: 'shadow'
                                        }
                },
                legend: { bottom: 0,
                                    type: 'scroll',},
                grid: {
                    top:'30',
                    left: '0',
                    right: '0',
                    bottom: '20',
                    containLabel: true
                },
                xAxis: [
                    {
                    type: 'category',
                    data:date
                    }
                ],
                yAxis: [
                    {
                    type: 'value'
                    }
                ],
                series: series
                }
                                chart_by_timeDimension.setOption( this.option_chart4)
            },
            getChartByTimeDimensionByBu:function(arr1,arr2,arr3){
                let _self = this
                let data_x = []
                 data_x = arr1.map(obj=>{return obj.dimension_time})
                let data_y = []
                for (let i = 0;i<arr3.length;i++){
                    let bu = arr3[i]['dimension_bu']
                    let count = []
                    for(let j = 0;j<data_x.length;j++){
                        var objectIndex = arr2.findIndex(object => ( object.dimension_time == data_x[j]) && ( object.dimension_bu == bu) );
                        
                      
                        if (objectIndex >= 0){
                            count.push(arr2[objectIndex].count)
                        } else {
                            count.push(0)
                        }
                    }
                   
                    let obj = [{bu_name:bu}]
                    obj.push({count:count})
                    data_y.push(obj)
                    
         
                }
             
                let date = []; //x轴日期
                let lenged = []; //series的个数
                let s = [];
                arr2.map((item) => {
                    date.push(item["dimension_time"]);
                    lenged.push(item["dimension_bu"]);

                });

                date = [...new Set(date)]; //去重
                // lenged = [...new Set(lenged)];?]
                lenged = data_y.map(obj=>{return obj[0].bu_name})
                let lengeng_color = []
                lenged.map((item,index) => { 
                    lengeng_color.push({name:item,itemStyle: {color: this.colorList[index]}})
                })
                
               
                let series = [];
                lenged.map((item,index) => { //生成  series
                    let obj = {
                        name: item,
                        type: 'line',
                       
                        lineStyle: {
                           
                                color:this.colorList[index],
                                normal: {
                                    color: this.colorList[index],
                                },

                            
                            
                        },
                        // areaStyle: {
                        //     color:this.colorList[index]
                        // },
                        emphasis: {
                        focus: 'series',
                        itemStyle: {
                            color: this.colorList[index], // 颜色
                            borderColor: this.colorList[index], // 图形的描边颜色
                            borderWidth: 1 // 描边的线宽
                        }
                        },
                        data: []
                    };
                    series.push(obj);
                    });
                    series.map((item1) => {

                           
                            item1.data = data_y[data_y.findIndex(object => ( object[0].bu_name == item1.name) )][1]['count'];
                        
                    })
                   
    
                echarts.init(document.getElementById('chart_by_timeDimension_bu')).dispose() 
                let chart_by_timeDimension = echarts.init(document.getElementById('chart_by_timeDimension_bu'))

                this.option_chart3 = {
                    title: {
                        text: _self.$t('message.chart_title_by_bu_trend').replace("{{metrics}}", _self.$t('message.'+_self.metrics)).replace("{{bu_dimension}}",_self.$t('message.'+_self.bu_dimension+'_Statistic')) , //主标题文本，'\n'指定换行,,
                        textStyle: { //主标题文本样式{"fontSize": 18,"fontWeight": "bolder","color": "#333"} 
                               fontSize: 12,
                               // color:'white'
                       },
                       x:'center'
                    },
                    color:[ '#3399CC',
                                '#006699',
                                '#66CCCC',
                                '#99CCFF',
                                '#CCFFFF',
                                '#99CCCC',
                                '#3399CC',
                                '#006699',
                                '#66CCCC',
                                '#99CCFF',
                                '#CCFFFF',
                                '#99CCCC',
                                '#3399CC',
                                '#006699',
                                '#66CCCC',
                                '#99CCFF',
                                '#CCFFFF',
                                '#99CCCC',],
                    tooltip: {
                        trigger: 'axis',
                        position: function (point, params, dom, rect, size) {
                            var x = 0; // x坐标位置
                                var y = 0; // y坐标位置
                                // 当前鼠标位置
                                var pointX = point[0];
                                var pointY = point[1];
                                // 提示框大小
                                var boxWidth = size.contentSize[0];
                                var boxHeight = size.contentSize[1];

                                // boxWidth > pointX 说明鼠标左边放不下提示框
                                if (boxWidth > pointX) {
                                    x = pointX + 10;
                                } else { // 左边放的下
                                    x = pointX - boxWidth - 10;
                                }

                                // boxHeight > pointY 说明鼠标上边放不下提示框
                                if (boxHeight > pointY) {
                                    y = 5;
                                } else { // 上边放得下
                                    y = pointY - boxHeight;
                                }
                                return [x, y];
                        },
                        textStyle: {
                                            fontSize:10  // 字体大小
                                        },
                        axisPointer: {
                        type: 'cross',
                       
                        label: {
                            backgroundColor: '#6a7985'
                        }
                        }
                    },
                    legend: {
                        // orient: 'vertical',
                        data:lenged,
                        bottom:0,
                    
                    // right: '0',
                    type: 'scroll',
                    // icon: "circle",//显示样式
                    pageIconColor: 'black', //图例分页左右箭头图标颜色
                        pageTextStyle:{  
                            color: 'black', //图例分页页码的颜色设置
                        },
                        pageIconSize: 12,  //当然就是按钮的大小
                        pageIconInactiveColor: '#7f7f7f',  // 禁用的按钮颜色
                        
                    },
                    toolbox: {
                        // feature: {
                        //   saveAsImage: {}
                        // }
                    },
                    grid: {
                        top:'30',

                        left: '15',
                        right: '40',
                        bottom: '20',
                        containLabel: true
                    },
                    xAxis: [
                        {
                        type: 'category',
                        boundaryGap: false,
                        data:date
                        }
                    ],
                    yAxis: [
                        {
                        type: 'value'
                        }
                    ],
                    series: series
                    }
                chart_by_timeDimension.setOption( this.option_chart3)
            },

            getChartByTimeDimension_2:function(arr){
                echarts.init(document.getElementById('chart_by_timeDimension_2')).dispose() 
                let chart_by_timeDimension = echarts.init(document.getElementById('chart_by_timeDimension_2'));
               
			let _self = this;
			chart_by_timeDimension.setOption( {
                title:{
					// show:false, //显示策略，默认值true,可选为：true（显示） | false（隐藏）
					text: 'Period ' + this.metrics, //主标题文本，'\n'指定换行
					textStyle: { //主标题文本样式{"fontSize": 18,"fontWeight": "bolder","color": "#333"} 
							fontSize: 12,
							// color:'white'
					},
					x:'20',
					
				},
                tooltip: {
                    trigger: 'item',
                    textStyle: {
                                            fontSize:10  // 字体大小
                                        },
                },
                legend: {
                    orient: 'vertical',
                    
                    right: 0,
                    type: 'scroll',
                    icon: "circle",//显示样式
                    pageIconColor: 'black', //图例分页左右箭头图标颜色
                        pageTextStyle:{  
                            color: 'black', //图例分页页码的颜色设置
                        },
                        pageIconSize: 12,  //当然就是按钮的大小
                        pageIconInactiveColor: '#7f7f7f',  // 禁用的按钮颜色
                    
                },
                series: [
                    {
                    name: this.metrics +' by ' +this.time_dimension,
                    type: 'pie',
                    radius: ['40%', '70%'],
                    center: ["35%", "52%"],
                    avoidLabelOverlap: false,
                    itemStyle: {
                         normal: {
                            color: function (colors) {// 第二长图的颜色
                                
                                return _self.colorList[colors.dataIndex];
                            }
                            },
                        borderRadius: 10,
                        borderColor: '#fff',
                        borderWidth: 2
                    },
                    label: {
                        show: false,
                        position: 'center'
                    },
                    emphasis: {
                        label: {
                        show: false,
                        fontSize: 40,
                        fontWeight: 'bold'
                        }
                    },
                    labelLine: {
                        show: false
                    },
                    data: 
                    arr.map(item=>{return {name:item.dimension_time,value:item.count}})
                    
                    }
                ]
                })
            },


            getChartByTimeDimension:function(arr){
                echarts.init(document.getElementById('chart_by_timeDimension')).dispose() 
                let chart_by_timeDimension = echarts.init(document.getElementById('chart_by_timeDimension'));
               
			    let _self = this;
                this.option_chart1 = {
                            title:{
                                // show:false, //显示策略，默认值true,可选为：true（显示） | false（隐藏）
                                text: _self.$t('message.chart_title_by_time_yoy').replace('{{metrics}}',_self.$t('message.'+_self.metrics)), //主标题文本，'\n'指定换行
                                textStyle: { //主标题文本样式{"fontSize": 18,"fontWeight": "bolder","color": "#333"} 
                                        fontSize: 12,
                                        // color:'white'
                                },
                                x:'center',
                                y:5
                            },
                            tooltip: {
                                trigger: 'axis',
                                textStyle: {
                                            fontSize:10  // 字体大小
                                        },
                                formatter:function(params) {
                                
                                    var str = params[0].name + '<br>'
                                    let circle = `<span style="display:inline-block;margin-right:5px;border-radius:50%;width:10px;height:10px;left:5px;background-color:`+params[0].color+
                                                            `"></span>`;
                                                            let circle_2 = `<span style="display:inline-block;margin-right:5px;border-radius:50%;width:10px;height:10px;left:5px;background-color:`+params[1].color+
                                                            `"></span>`;
                                    str += circle+params[0].seriesName + ' : ' + params[0].value + '<br>'
                                    str += circle_2+params[1].seriesName + ' : ' + params[1].value + '%<br>'
                                    
                                    return str;
                                }

                            },
                            legend: {
                                bottom:'0',
                                x:'center',
                                show:true,
                                // orient: 'vertical',
                                textStyle:{
                                    fontSize: 12,
                                        // color: 'white'
                                },
                                //data: ['Actual Data', 'Last Forecast', 'New Forecast', 'BU Original Forecast', 'ForwardKeys']
                                // data: ['Acitivies']
                            },
                            grid: {
                                left: '5',
                                top:'38',
                                right: '5',
                                bottom: '25',
                                containLabel: true
                            },
                            toolbox: {

                            },
                            xAxis: {
                                
                                data: arr.map(obj=>{return obj.dimension_time_y})
                            },
                            yAxis: [{
                                type: 'value',},
                                {
                                    type: 'value',
                                    splitLine:{
                                        show:false
                                    },
                                    
                                    // name: 'Temperature',
                                    // min: 0,
                                    // max: 25,
                                    // interval: 5,
                                    offset: 45,
                                    axisLabel: {
                                        formatter: '{value} %',
                                        align: "right", // 右对齐
                                    },
                                    axisTick:{ //y轴刻度线
                                        show:false
                                    },
                                    axisLine:{ //y轴
                                        show:false
                                    },

                                }
                                
                            ],
                            series: [
                                {
                                    // name: 'Actual Data',
                                    name: _self.$t('message.'+_self.metrics),
                                    type: 'bar',
                                    barMaxWidth: '45%',
                                    
                                    
                                    data: arr.map(obj=>{return obj.count_y}),
                                    itemStyle: {
                                        normal: {
                                            color:'#3399CC',// 第一张图的颜色
                                            label: {
                                                show: true, //开启显示
                                                position: 'top', //内部显示
                                                formatter:function (params) {
                                                    if (params.value > 0) {
                                                        return params.value;
                                                        } else {
                                                        return '';
                                                        }
                                                },
                                                textStyle: {
                                                    //数值样式
                                                    color: 'black',
                                                    fontSize: 12,
                                                },
                                            },
                                        },
                                    },


                                },
                                {
                                    name: _self.$t('message.YOY'),
                                    type: 'line',
                                    yAxisIndex: 1,
                                    tooltip: {
                                        valueFormatter: function (value) {
                                        return value + ' %';
                                        }
                                    },
                                    data:  arr.map(obj=>{return obj.yoy}),
                                    itemStyle: {
                                        normal: {
                                            color:_self.colorList[2],// 第一张图的颜色
                                    },
                                }}
                                
                            ]
			}
			    chart_by_timeDimension.setOption(this.option_chart1)
            },
            submit(){
                this.drawer = true
               
                let api_url = _global.serverSrc + "/get_statistic_v2/" + "?from=" + this.selectDate[0]+ "&to="+  this.selectDate[1]+'&metrics='+this.metrics.replace(/\s+/g,"")+'&bu_dimension='+this.bu_dimension+'&bu_dimension_filer='+this.bu_dimension_filter+'&time_dimension='+this.time_dimension+'&bu='+this.bu;
                let obj = {'email': JSON.parse(sessionStorage.getItem('User'))}
                this.$axios
                    .post(api_url, obj)
                    .then((response) => {
                        if (response.data.total == 0){
                            this.$alert(this.$t("message.no_data_statistic_v2").replace("{{metrics}}",this.$t("message."+this.metrics)),'Alert', {
						cancelButtonText: 'OK',
						callback: action => {
                            this.total_count=0,
                            this.metrics_result = this.metrics
                this.total_count_last=0,
                this.yoy=0,
                            echarts.init(document.getElementById('chart_by_timeDimension')).dispose()
                            // echarts.init(document.getElementById('chart_by_timeDimension_2')).dispose()
                            echarts.init(document.getElementById('chart_by_timeDimension_bu')).dispose()
                            echarts.init(document.getElementById('chart_by_timeDimension_bu_2')).dispose()
                            echarts.init(document.getElementById('chart_by_bu_2')).dispose()
                            echarts.init(document.getElementById('chart_by_user')).dispose()
						}
					});
                        } else {
                            this.metrics_result = this.metrics
                            this.data_response = response.data
                            this.total_count = response.data.total
                        this.total_count_last = response.data.total_last
                        
                        if(this.total_count_last == 0){
                            if( this.total_count != 0){
                                this.yoy =this.total_count *100 
                            } else {
                                this.yoy = 0
                            }
                            
                           
                        } else {
                           
                            this.yoy = Math.round((response.data.total - response.data.total_last)*100/response.data.total_last,2)
                        }
                       
                        this.getChartByTimeDimension(response.data.db_by_time_dimension_list_last)
                        // this.getChartByTimeDimension_2(response.data.db_by_time_dimension_list)
                        this.getChartByTimeDimensionByBu(response.data.db_by_time_dimension_list,response.data.db_by_time_bu,response.data.db_by_bu_dimension_list)
                        this.getChartByTimeDimensionByBu_2(response.data.db_by_time_dimension_list,response.data.db_by_time_bu,response.data.db_by_bu_dimension_list)
                        this.getChartByBU(response.data.db_by_bu_dimension_list)
                        this.getChartByuser(response.data.db_user)
                        }
                       
                        

                    })
            },
            initHeight() {
// 设置或获取位于对象最顶端和窗口中可见内容的最顶端之间的距离 (被卷曲的高度)
var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
//如果被卷曲的高度大于吸顶元素到顶端位置 的距离
this.isFixed = scrollTop > this.offsetTop ? true : false;
}
        },
        computed: {
            localLang() {
                return this.$i18n.locale;
            }
        },
        watch:{
            localLang() {
                this.time_dimension_option = [{name:this.$t('message.Year'),id:'Year'},{name:this.$t('message.Year-Month'),id:'Year-Month'},{name:this.$t('message.Year-Week'),id:'Year-Week'},{name:this.$t('message.Date'),id:'Date'},{name:this.$t('message.Hour'),id:'Hour'}]
             
                this.bu_dimension_option.map((item) => {
                    item.name = this.$t('message.'+item.id+'_Statistic')
                    

                })


                echarts.init(document.getElementById('chart_by_user')).dispose() 
                this.option_chart5.title.text = this.$t('message.chart_title_by_user').replace("{{metrics}}", this.$t('message.'+this.metrics))
                let chart_5 = echarts.init(document.getElementById('chart_by_user'));
                chart_5.setOption(this.option_chart5)

                echarts.init(document.getElementById('chart_by_timeDimension_bu_2')).dispose() 
                this.option_chart4.title.text = this.$t('message.chart_title_bu_bu_stacked').replace("{{metrics}}", this.$t('message.'+this.metrics)).replace("{{bu_dimension}}",this.$t('message.'+this.bu_dimension+'_Statistic'))
                let chart_4 = echarts.init(document.getElementById('chart_by_timeDimension_bu_2'));
                chart_4.setOption(this.option_chart4)

                echarts.init(document.getElementById('chart_by_timeDimension')).dispose() 
                this.option_chart1.title.text = this.$t('message.chart_title_by_time_yoy').replace('{{metrics}}',this.$t('message.'+this.metrics))
                let chart_1 = echarts.init(document.getElementById('chart_by_timeDimension'));
                chart_1.setOption(this.option_chart1)

                echarts.init(document.getElementById('chart_by_bu_2')).dispose() 
                this.option_chart2.title.text =this.$t('message.chart_title_by_bu').replace("{{metrics}}", this.$t('message.'+this.metrics)).replace("{{bu_dimension}}",this.$t('message.'+this.bu_dimension+'_Statistic'))
                let chart_2 = echarts.init(document.getElementById('chart_by_bu_2'));
                chart_2.setOption(this.option_chart2)

                echarts.init(document.getElementById('chart_by_timeDimension_bu')).dispose() 
                this.option_chart3.title.text =this.$t('message.chart_title_by_bu_trend').replace("{{metrics}}", this.$t('message.'+this.metrics)).replace("{{bu_dimension}}",this.$t('message.'+this.bu_dimension+'_Statistic')) 
                let chart_3= echarts.init(document.getElementById('chart_by_timeDimension_bu'));
                chart_3.setOption(this.option_chart3)
            }
        },
        mounted() {
            let UserAuthority = JSON.parse(sessionStorage.getItem("UserAuthority"));

            this.bu = UserAuthority.bu
            this.$refs.head_page.update_user_name();
            var now = new Date();
            var now_month_ago = new Date((new Date().getTime() - 14 * 24 * 3600 *1000))
            // console.log(nouw_month_ago)
            this.selectDate = [now_month_ago.getFullYear() + "-" +((now_month_ago.getMonth()+1)<10?"0":"")+(now_month_ago.getMonth()+1)+"-"+(now_month_ago.getDate()<10?"0":"")+now_month_ago.getDate(),now.getFullYear() + "-" +((now.getMonth()+1)<10?"0":"")+(now.getMonth()+1)+"-"+(now.getDate()<10?"0":"")+now.getDate()]
            // console.log(now_month_ago.getFullYear() + "-" +((now_month_ago.getMonth()+1)<10?"0":"")+(now_month_ago.getMonth()+1)+"-"+(now_month_ago.getDate()<10?"0":"")+now_month_ago.getDate())
            window.addEventListener('scroll', this.initHeight);
            this.$nextTick(() => {
            //获取对象相对于版面或由 offsetTop 属性指定的父坐标的计算顶端位置 
            this.offsetTop = document.querySelector('#searchDiv').offsetTop;
                })
            this.bu_dimension_option=[{name:this.$t('message.BU_Statistic'),id:'BU'}]
            this.bu_dimension = 'BU'
            if(this.bu == 'DDV' || this.bu == 'Central'){
                this.bu_dimension_filter_option=[{name:'DDV',id:'DDV'},{name:'Central',id:'Central'},{name:'Nanjing',id:'Nanjing'},{name:'Wuhan',id:'Wuhan'},{name:'Shenzhen',id:'Shenzhen'},{name:'Chongqing',id:'Chongqing'},{name:'Chengdu',id:'Chengdu'},{name:'Shanghai',id:'Shanghai'},{name:'Beijing',id:'Beijing'},{name:'Hongkong',id:'Hongkong'}]
            } else {
                this.bu_dimension_filter_option=[{name:this.bu,id:this.bu}]
            }
            // this.bu_dimension_filter_option=[{name:'DDV',id:'DDV'},{name:'Central',id:'Central'},{name:'Nanjing',id:'Nanjing'},{name:'Wuhan',id:'Wuhan'},{name:'Shenzhen',id:'Shenzhen'},{name:'Chongqing',id:'Chongqing'},{name:'Chengdu',id:'Chengdu'},{name:'Shanghai',id:'Shanghai'}]
            this.bu_dimension_filter_option.map((item) => {
                    this.bu_dimension_filter.push(item["id"]);
                    

                })
            this.time_dimension_option = [{name:this.$t('message.Year'),id:'Year'},{name:this.$t('message.Year-Month'),id:'Year-Month'},{name:this.$t('message.Year-Week'),id:'Year-Week'},{name:this.$t('message.Date'),id:'Date'},{name:this.$t('message.Hour'),id:'Hour'}]
            this.submit()
        },
//回调中移除监听
destroyed() {
window.removeEventListener('scroll', this.handleScroll)
},
    }

</script>          
<style lang="scss" scoped>
.box-card{
    /deep/.el-card__body {
    padding: 10px;
  }
}
    .is_fixed{
     width: 25%;
     position: fixed;
     top: 0;
     z-index: 999;
}
.isfixed2{
    display: none;
}
</style>